<template>
  <div class="container">
    <el-row type="flex" align="middle" justify="start">
      <el-col :span="6" style="text-align: center">
        <el-avatar :size="72" icon="el-icon-user-solid" />
      </el-col>
      <el-col :span="18">
        <div style="font-size:1.3em;font-weight: bolder;height: 30px;line-height: 30px"><ellipsis :length="25">{{ user.depart }}</ellipsis></div>
        <div style="font-size: 1em;height: 30px;line-height: 30px">姓名：{{ user.name }}</div>
<!--        <div style="font-size: 1em;height: 30px;line-height: 30px">角色：<ellipsis :length="30">{{ user.role }}</ellipsis></div>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>

import Ellipsis from '../Ellipsis/Ellipsis'

export default {
  name: 'UserInfo',
  components: {
    Ellipsis
  },
  data () {
    return {
      user: {
        depart: '',
        name: '',
        role: ''
      }
    }
  },
  created () {
    console.info(this.$store.state.userInfo)
    this.user.name = this.$store.state.userInfo.showName
    this.user.depart = this.$store.state.userInfo.deptName
    /*
    this.user.role = this.$store.state.userInfo.postNameList.join('、') */
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .container{
    padding:20px 0;
    border-bottom: 1px solid #e4e4e4;
    height: 125px;
    /deep/.el-avatar{
      font-size:50px;
      border-radius:40% !important;
      background-color:rgb(117,150,255) !important;
    }
  }
</style>
